import { collect } from 'collect.js';

export default function str(value) {
  return new Stringable(value);
}

export class Stringable {
  value;

  constructor(value) {
    this.value = value;
  }

  start(prefix) {
    if (!this.value) {
      return this;
    }

    if (this.value.startsWith(prefix)) {
      return this;
    }

    this.value = `${prefix}${this.value}`;

    return this;
  }

  startsWith(prefix) {
    if (!this.value) {
      return false;
    }

    return this.value.startsWith(prefix);
  }

  toUrl() {
    if (!this.value) {
      return this;
    }

    if (this.startsWith('http://') || this.startsWith('https://')) {
      return this;
    }

    return this.start('https://');
  }

  capitalize() {
    this.value = this.value.charAt(0).toUpperCase() + this.value.slice(1);

    return this;
  }

  ltrim(char = ' ') {
    const escaped = char.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    const regex = new RegExp(`^${escaped}+`);

    this.value = this.value.replace(regex, '');

    return this;
  }

  squish() {
    this.value = this.value.replace(/\s+/g, ' ').trim();

    return this;
  }

  padLeft(char) {
    if (!this.value.startsWith(char)) {
      this.value = char + this.value;
    }

    return this;
  }

  ucfirst() {
    this.value = this.value.charAt(0).toUpperCase() + this.value.slice(1);

    return this;
  }

  headline() {
    const ucsplit = (value) => value.replace(/([a-z])([A-Z])/g, '$1 $2').split(/[\s_-]+/);

    let parts = this.value.split(' ');

    if (parts.length === 1) {
      parts = ucsplit(this.value);
    } else {
      parts = parts.flatMap(ucsplit);
    }

    parts = parts.map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase());

    const collapsed = parts.join('_').replace(/[-_ ]+/g, '_');

    this.value = collapsed.split('_').filter(Boolean).join(' ');

    return this;
  }

  prepend(...values) {
    this.value = collect(values).implode('') + this.value;

    return this;
  }

  append(...values) {
    this.value += collect(values).implode('');

    return this;
  }

  when(condition, callback) {
    return condition ? callback(this) : this;
  }

  lower() {
    this.value = this.value.toLowerCase();

    return this;
  }

  upper() {
    this.value = this.value.toUpperCase();

    return this;
  }

  toString() {
    return this.value;
  }

  toHuman() {
    this.value = this.headline().lower().ucfirst().toString();

    return this;
  }

  static toHuman(value) {
    return str(value).headline().lower().ucfirst().toString();
  }
}
